(ns manage.duplicate-adset-ocp.db
  (:require [clojure.spec.alpha :as spec]
            [common.form.core :as form]
            [common.util :as util]
            [manage.spec.adset :as spec.adset]
            [phrase.alpha :as p]
            [re-frame.core :as rf]))

(def valid-cfn-version?
  #{:draft :published})

(spec/def ::campaignId
  int?)

(spec/def ::duplicate
  valid-cfn-version?)

(defmulti value :include-content-function)

(defmethod value false []
  (spec/keys :req-un [::spec.adset/name ::campaignId
                      ::includeTemplate
                      ::include-content-function]))

(defmethod value true []
  (spec/keys :req-un [::spec.adset/name ::campaignId
                      ::includeTemplate
                      ::include-content-function
                      ::duplicate]))

(spec/def ::value
  (spec/multi-spec value :include-content-function))

(p/defphraser int?
  {:via [::campaignId]}
  [_ problem key]
  {:message "The campaign id has to be an integer."
   :in (:in problem)
   :problem problem})

(p/defphraser valid-cfn-version?
  [_ problem]
  {:message "Please select a content function version."
   :in (:in problem)
   :problem problem})

(def validate-form
  (rf/enrich
   (form/get-validate-form-fn :form.adset-duplicate ::value)))

(rf/reg-event-fx :form.adset-duplicate/init-form
  [(rf/inject-cofx :sub :context)
   (rf/inject-cofx :sub :resource.content-function-version/active-version)
   (rf/inject-cofx :sub :resource.content-function-version/versions)]
  (fn [{:keys [context]
        :resource.content-function-version/keys [active-version versions]} _]
    {:fx [[:dispatch [:form.adset-duplicate/init {:name ""
                                                  :campaignId (-> context :campaign-id int)
                                                  :include-content-function (boolean (seq versions))
                                                  :includeTemplate true
                                                  :duplicate (keyword (:name active-version))}]]]}))

(rf/reg-event-fx :form.adset-duplicate/on-change-include-cfn
  [(rf/inject-cofx :sub :resource.content-function-version/active-version)]
  (fn [{:resource.content-function-version/keys [active-version]} [_ path value]]
    {:fx [[:dispatch [:form.adset-duplicate/on-change path value]]
          [:dispatch [:form.adset-duplicate/on-change [:duplicate] (if value
                                                                     (keyword (:name active-version))
                                                                     nil)]]]}))

(defn get-field-errors
  [mapping error]
  (when-let [spec (get-in error [:error :spec])]
    (when-let [first-error (first spec)]
      (let [error-code-by-field (util/map-vals first first-error)]
        (into {}
              (keep (fn [[field error-code]]
                      (when-let [error-message (get-in mapping [field error-code])]
                        [field error-message]))
                    error-code-by-field))))))

(def error-mapping
  {:name {"duplicate" "Name must be unique"}})

(rf/reg-event-db :form.adset-duplicate/submit-failure
  (fn [db [_ response]]
    (let [error-messages (get-field-errors error-mapping (:value response))
          errors (->> error-messages
                      (map (fn [[k v]]
                             [[k] [{:message v}]]))
                      (into {}))]
      (assoc-in db [:form.adset-duplicate :errors] errors))))

(def use-error-message (partial form/use-error-message :form.adset-duplicate))

(def use-bind-control (partial form/use-bind-control :form.adset-duplicate))

(form/register-form {:namespace :form.adset-duplicate
                     :validate-form validate-form})
